export default "__VITE_ASSET__CgJeoxJp__"